import { useQuery } from '@tanstack/react-query'
import { TeachersService } from '@/shared/api/rest/services/teachers.service'
import { getFromLocalStorage } from '@/shared/utils/localStorageHelper'
import { BranchType } from '@/shared/api/hooks/useBranches'

/**
 * The signed-in teacher's own branch, from their teacher record.
 *
 * Shares the `teacher-me` cache entry with the notification feed. Falls back to
 * the branch picker only as a default for form fields — records with no branch
 * on file are common, so a null here is expected rather than exceptional.
 */
export const useMyTeacherBranchId = () => {
    const { data: me, isLoading } = useQuery({
        queryKey: ['teacher-me'],
        queryFn: () => TeachersService.me().catch(() => null),
        staleTime: 5 * 60_000
    })

    const picked = getFromLocalStorage<BranchType>('currentBranch')

    return {
        branchId: me?.branchId || picked?.value || null,
        /** True when the value came from the teacher's record, not the picker. */
        isOwnBranch: !!me?.branchId,
        loading: isLoading
    }
}
